import {createSlice} from "@reduxjs/toolkit";

const initialNotificationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  notificationForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState: initialNotificationState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // createNotification
    notificationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    
  }
});
